import {axiosClient} from "./client";

import {COUNTRIES_GET, EXPERT_PROFILE_CREATE, EXPERT_PROFILE_GET, EXPERT_PROFILE_UPDATE, CONTACT_US} from "./client/endpoints";

const expertProfileCreate = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(EXPERT_PROFILE_CREATE, data);
  return response.data;
}

const expertProfileUpdate = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(EXPERT_PROFILE_UPDATE, data);
  return response.data;
}

const expertProfileGet = async (): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(EXPERT_PROFILE_GET);
    return response.data;
  } catch (e) {
    return null;
  }
};

const countriesGet = async (): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(COUNTRIES_GET);

    return response.data;
  } catch (e) {
    return null;
  }
};

const contactUs = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(CONTACT_US, data);
  return response.data;
}

const ExpertProfileService = {
  expertProfileUpdate,
  expertProfileGet,
  expertProfileCreate,
  countriesGet,
  contactUs
};

export default ExpertProfileService;
